module.exports = __webpack_public_path__ + "img/trash.665926e2.svg";